import type { CheckResult } from './types';

/**
 * The typical response time of a batch. Port of Android's
 * `domain/usecase/averageResponseMs`.
 *
 * **Healthy rows only**, and that is a data decision rather than a display one,
 * which is why it lives here beside `aggregate` and not on the screen that shows
 * the number. The two rows it excludes are excluded for different reasons and
 * both would corrupt the figure:
 *
 * - a **timeout** contributes the full `PROBE_TIMEOUT_MS` ceiling, so one dead
 *   link drags the average toward 10s and the dashboard reports a "typical
 *   response time" for a link that never responded;
 * - a **mixed-content** rejection contributes a zero nobody measured — Safari
 *   refused before anything left the phone — and zeros pull the other way, which
 *   is worse: the number looks better the more links are unmeasurable.
 *
 * `null` rather than `0` when nothing is healthy: no measurement is not a
 * measurement of zero, and the screen shows an em dash for it.
 */
export function averageResponseMs(results: readonly CheckResult[]): number | null {
  let sum = 0;
  let count = 0;
  for (const result of results) {
    if (result.healthStatus !== 'healthy') continue;
    sum += result.responseMs;
    count += 1;
  }
  return count === 0 ? null : Math.round(sum / count);
}
